// extracted by mini-css-extract-plugin
module.exports = {"extra-zeros":"style_extra-zeros__CiZRI"};